// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "root-XpTA_";
var _3 = "success-2bFc2";
var _4 = "loading-2ZEN9";
var _5 = "colorPrimary-2cyi4";
export { _1 as "__esModule", _2 as "root", _3 as "success", _4 as "loading", _5 as "colorPrimary" }
export default { "__esModule": _1, "root": _2, "success": _3, "loading": _4, "colorPrimary": _5 }
